import React from 'react';
import { Button, Stack } from '@mui/material';

export const CalendarActions = () => {
  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button size="small" variant="contained" onClick={() => {}}>
        New Activity
      </Button>
    </Stack>
  );
};
